import VIEWPORTS from '../plugins/viewports'
import TAGMANAGER from '../plugins/tagmanager'
import PARTSLOADER from '../plugins/partsloader'
import CONTENT_TITLE from '../plugins/contentTitle'
import GOOG_TRANSLATE from '../plugins/googletranslate'
import SHOP_SEARCH from '../plugins/shop_search'
import GET_CATEGORIES from '../plugins/getCategories'
import GET_ARTICLES from '../plugins/getArticles'
import SCROLL_NAV from '../plugins/scrollNav'
import GET_COPYRIGHT from '../plugins/getCopyright'
import {DRAWER_NAV,COLLAPSE_NAV} from '../plugins/drawerNav'
import CONTENT_IMAGE_SIZE from '../plugins/contentImageSize';

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

export default function INIT() {
  /*****
   * Promise
   */
  window.load = {
    'header': new $.Deferred,
    'contentFooter': new $.Deferred,
    'footer': new $.Deferred,
    'mapScript': new $.Deferred,
  }

  VIEWPORTS() // Viewportの置き換え
  TAGMANAGER() // GoogleTagManagerの挿入
  GOOG_TRANSLATE('UA-44649343-10') // GoogleTranslate(引数はトラッキングコード)
  SHOP_SEARCH('//www.mvcoffee.net/') // 検索ボックスの表示(引数は送信先)
  DRAWER_NAV()
  COLLAPSE_NAV({
    query: '[data-plugin="collapseNav"]',
    trigger: '[role="parent"]',
    target: '[role="child"]',
    activeClass: 'is-active'
  })

  //header.html, footer.html読み込み
  PARTSLOADER([
    {
      name: 'footer',
      loadhtml: '/asset/html/footer.html?ts=20190826',
      target: 'footer',
      method:'replaceWith'
    },
    {
      name: 'header',
      loadhtml: '/asset/html/header.html?ts=20190826',
      target: 'header',
      method:'replaceWith'
    }
  ])

  // プライバシー・会社概要・サイトマップのコンテンツタイトル
  CONTENT_TITLE({
    'sitemap':'サイトマップ',
    'privacy':'プライバシーポリシー',
    'profile':'会社概要'
  })

  CONTENT_IMAGE_SIZE()
  
  // header loaded
  window.load.header.then(() => {
    SCROLL_NAV('.p-gnav') // スワイプ対応ナビ
    $('nav.p-gnav').currentMenu({mode:1,default:999})
  })

  // footer loaded
  window.load.footer.then(() => {
    GET_CATEGORIES('.p-footer') // カテゴリ取得プラグイン
    GET_ARTICLES('.p-footer') // 記事データ取得プラグイン
    GET_COPYRIGHT() // コピーライト取得プラグイン
    $('footer .p-footer__nav').currentMenu({mode:0,default:999})
  })

  // DOM Ready
  $(() => {
    // <body>にクラス付与
    $.bodyClass();
    // htmlデータ読み込み
    $('[data-load-html]').loadHtml();
    // ページングテキスト
    $.pagingText({
      prev:'Prev',
      next:'Next',
      list:'List'
    })
    // ページトップリンクをスクロール量で表示する
    $.scrollspy({
      trigger:200,
      onBefore(/* pos */) {
        $('.p-gotop__wrap').addClass('hidden');
      },
      onAfter() {
        $('.p-gotop__wrap').removeClass('hidden');
      }
    })
  })
  
}